import React from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import DocumentTypeList from './DocumentTypeList';

const DocumentType = () => {
	document.title = 'Tipo de Documento | OpenLink';

	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					<BreadCrumb
						title="Tipo de Documento"
						pageTitle="Configuración"
					/>
					<DocumentTypeList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default DocumentType;
